import React from 'react';
import { ContactInfo } from '../../Utils/Data';
import ContactInquiryForm from './ContactInquiryForm';
import LetsTalkPhoneImage from './LetsTalkPhoneImage';

const img = (path) => `${process.env.PUBLIC_URL}/assets/images/${path}`;

const LetsTalkSection = ({ copy, sourcePage }) => (
  <div className="rs-contact contact-style1 bg3 contact-split-layout">
    <div className="row">
      <div className="col-lg-5 con-left-6">
        <div className="contact-section">
          <div className="contact-wrap">
            <div className="sec-title mb-45">
              <span className="sub-text">
                <img src={img('shape-1.png')} alt="Images" />
                {copy.letsTalk}
              </span>
              <h2 className="title">{copy.projectQuestion}</h2>
            </div>
            <ContactInquiryForm
              sourcePage={sourcePage}
              placeholders={{
                name: copy.placeholderName,
                email: copy.placeholderEmail,
                phone: copy.placeholderPhone,
                service: copy.placeholderService,
                other: copy.placeholderOther,
                message: copy.placeholderMessage,
              }}
              submitClassName="readon more submit"
              submitLabel={copy.submitNow}
            />
          </div>
        </div>
      </div>
      <div className="col-lg-3 con-right-6">
        <div className="contact-box-item">
          <div className="contact-box mb-20">
            <div className="contact-icon">
              <img src={img('contact/style1/icons/1.png')} alt="images" />
            </div>
            <div className="content-text">
              <h4 className="title">
                <a href={ContactInfo.office_maps_share_url} target="_blank" rel="noopener noreferrer">
                  {copy.officeTitle}
                </a>
              </h4>
              <p className="services-txt">
                {ContactInfo.office_address_line1}
                <br />
                {ContactInfo.office_address_line2}
              </p>
            </div>
          </div>
          <div className="contact-box mb-20">
            <div className="contact-icon">
              <img src={img('contact/style1/icons/2.png')} alt="images" />
            </div>
            <div className="content-text">
              <h4 className="title">
                <a href={`mailto:${ContactInfo.contact_email}`}>{copy.emailUs}</a>
              </h4>
              <p className="services-txt">
                <a href={`mailto:${ContactInfo.contact_email}`}>{ContactInfo.contact_email}</a>
                <br />
                <a href={`mailto:${ContactInfo.hr_email}`}>{ContactInfo.hr_email}</a>
              </p>
            </div>
          </div>
          <div className="contact-box">
            <div className="contact-icon">
              <img src={img('contact/style1/icons/3.png')} alt="images" />
            </div>
            <div className="content-text">
              <h4 className="title">
                <a href={`tel:${ContactInfo.contact_phone}`}>{copy.callUs}</a>
              </h4>
              <p className="services-txt">
                <a href={`tel:${ContactInfo.contact_phone}`}>{ContactInfo.contact_phone}</a>
                <br />
                <a href={`tel:${ContactInfo.contact_phone2}`}>{ContactInfo.contact_phone2}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <LetsTalkPhoneImage />
    </div>
  </div>
);

export default LetsTalkSection;
